module.exports = "/packs/schedule_calendar_banner-561d8d03a9f4efd8cea37caeff86e66d.svg";